import PropTypes from 'prop-types'
import React from 'react'
import { Item } from '../Item'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { useFormikContext } from 'formik'
import { getPackages } from 'SRC/modules/ads/add/selectors'
import { Header } from 'SRC/modules/ads/shared/components/FormElements'

const List = ({ packages }) => {
  const formik = useFormikContext()
  const { t } = useTranslation('common')

  if (!formik) return null

  return (
    <React.Fragment>
      <Header title={t('Izaberi tip oglasa')} key='promoPeriods-header' />

      <div className='tipovi-oglasa' key='promoPeriods-list'>
        {
          packages.map(item =>
            <Item
              {...item}
              key={`type-${item.id}`}
              activeType={formik.values.listing}
              onClick={event => {
                const value = Number(event.target.dataset.id)
                console.log('value', value)
                formik.setFieldValue('listing', value)
              }}
            />
          )
        }
      </div>
    </React.Fragment>
  )
}

List.propTypes = {
  change: PropTypes.func.isRequired,
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  }))
}

List.displayName = 'PromoPeriods'

const mapStateToProps = (state, ownProps) => {
  return {
    packages: getPackages(state)
  }
}

export default connect(mapStateToProps)(List)
